import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/anime';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold mb-4 text-background-50">
              {t('site.name')}
            </h4>
            <p className="text-sm leading-relaxed text-foreground-300">
              {t('footer.about')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4 text-background-50">
              {t('footer.quickLinks')}
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                {t('nav.home')}
              </Link>
              <Link to="/category/mystery" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                {t('nav.category')}
              </Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                {t('nav.about')}
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4 text-background-50">
              {t('footer.categories')}
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4 text-background-50">
              {t('footer.contact')}
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-300">
              <p>contact@animerec.example.com</p>
              <p>关注我们的社交媒体</p>
              <div className="flex gap-4 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-accent-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-accent-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-accent-500 transition-colors" aria-label="Bilibili">
                  <i className="ri-bilibili-line text-background-50"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">使用条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}